module.exports = __webpack_public_path__ + "static/media/9DESA28.d61fcfa9.jpg";